import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hint" }
const _hoisted_2 = { class: "hint-content has-mouse" }
const _hoisted_3 = { class: "hint-content has-touch" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(" Beweeg over de punten en ontdek de verhalen "),
      _createVNode(_component_Icon, {
        class: "help-icon",
        name: "hover"
      })
    ]),
    _createElementVNode("p", _hoisted_3, [
      _createVNode(_component_Icon, {
        class: "help-icon",
        name: "touch"
      }),
      _createTextVNode(" Tik op een blaadje om melati's te ontdekken ")
    ])
  ]))
}